"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/toConsumableArray.js"));

var _typeof2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/typeof.js"));

var _defineProperty2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/defineProperty.js"));

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.string.iterator.js");

var _vue = _interopRequireDefault(require("vue"));

var _props = _interopRequireDefault(require("./props"));

var _main = _interopRequireDefault(require("../../search/src/main.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'ElSearchTablePagination',
  components: {
    searchForm: _main.default
  },
  props: _props.default,
  data: function data() {
    var _this = this;

    return {
      Vue: _vue.default,
      pagination: {
        pageIndex: 1,
        pageSize: function () {
          var pageSizes = _this.pageSizes;

          if (pageSizes.length > 0) {
            return pageSizes[0];
          }

          return 10;
        }()
      },
      total: 0,
      paginationLayoutTemp: 'prev, pager, next, sizes',
      loading: false,
      tableData: [],
      cacheLocalData: []
    };
  },
  computed: {
    newSlotScope: function newSlotScope() {
      return Number(_vue.default.version.replace(/\./g, '')) >= 250;
    }
  },
  watch: {
    data: function data(value) {
      this.loadLocalData(value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    // event: expand changed to `expand-change` in Element v2.x
    this.$refs['table'].$on('expand', function (row, expanded) {
      return _this2.emitEventHandler('expand', row, expanded);
    });
    var type = this.type,
        autoLoad = this.autoLoad,
        data = this.data,
        formOptions = this.formOptions,
        params = this.params;

    if (type === 'remote' && autoLoad) {
      if (formOptions) {
        this.$refs['searchForm'].getParams(function (error, formParams) {
          if (!error) {
            _this2.fetchHandler(Object.assign(formParams, params));
          }
        });
      } else {
        this.fetchHandler(params);
      }
    } else if (type === 'local') {
      this.loadLocalData(data);
    }
  },
  methods: {
    handleSizeChange: function handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.dataChangeHandler();
    },
    handleCurrentChange: function handleCurrentChange(pageIndex) {
      this.pagination.pageIndex = pageIndex; // 当前页条目数大于等于页面限制条数  可以请求下一页

      this.total >= this.pagination.pageSize ? this.dataChangeHandler() : null;
    },
    searchHandler: function searchHandler() {
      var resetPageIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (resetPageIndex) {
        this.pagination.pageIndex = 1;
      }

      this.dataChangeHandler(arguments[0]);
    },
    dataChangeHandler: function dataChangeHandler() {
      var type = this.type;

      if (type === 'local') {
        this.dataFilterHandler(arguments[0]);
      } else if (type === 'remote') {
        this.fetchHandler(arguments[0]);
      }
    },
    dataFilter: function dataFilter(data) {
      var _this$pagination = this.pagination,
          pageIndex = _this$pagination.pageIndex,
          pageSize = _this$pagination.pageSize;
      return data.filter(function (v, i) {
        return i >= (pageIndex - 1) * pageSize && i < pageIndex * pageSize;
      });
    },
    // 本地静态数据请求 封装
    dataFilterHandler: function dataFilterHandler(formParams) {
      var cacheLocalData = this.cacheLocalData,
          params = this.params,
          pagination = this.pagination;
      var pageIndex = pagination.pageIndex,
          pageSize = pagination.pageSize;
      var mergeParams = Object.assign(params, formParams);
      var validParamKeys = Object.keys(mergeParams).filter(function (v) {
        return mergeParams[v] !== undefined && mergeParams[v] !== '';
      });
      var searchForm = this.$refs['searchForm'];
      var paramFuzzy;

      if (searchForm) {
        paramFuzzy = searchForm.getParamFuzzy();
      }

      if (validParamKeys.length > 0) {
        var validData = cacheLocalData.filter(function (v) {
          var valids = [];
          validParamKeys.forEach(function (vv) {
            if (typeof v[vv] === 'number') {
              valids.push(paramFuzzy && paramFuzzy[vv] ? String(v[vv]).indexOf(String(mergeParams[vv])) !== -1 : String(v[vv]) === String(mergeParams[vv]));
            } else {
              valids.push(paramFuzzy && paramFuzzy[vv] ? v[vv].indexOf(mergeParams[vv]) !== -1 : v[vv] === mergeParams[vv]);
            }
          });
          return valids.every(function (vvv) {
            return vvv;
          });
        });
        this.tableData = this.dataFilter(validData);
        this.total = validData.length;
      } else {
        this.total = cacheLocalData.length;
        this.tableData = this.dataFilter(cacheLocalData);
      }
    },
    // 远程掉去API 请求后端数据封装
    fetchHandler: function fetchHandler() {
      var _this3 = this;

      var formParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.loading = true;
      var fetch = this.fetch,
          method = this.method,
          url = this.url,
          $axios = this.$axios,
          headers = this.headers,
          listField = this.listField,
          pageIndexKey = this.pageIndexKey,
          pageSizeKey = this.pageSizeKey,
          totalField = this.totalField,
          params = this.params,
          showPagination = this.showPagination,
          pagination = this.pagination;
      params = JSON.parse(JSON.stringify(Object.assign(params, formParams)));

      if (showPagination) {
        var _Object$assign;

        params = Object.assign(params, (_Object$assign = {}, (0, _defineProperty2.default)(_Object$assign, pageIndexKey, pagination.pageIndex - 1), (0, _defineProperty2.default)(_Object$assign, pageSizeKey, pagination.pageSize), _Object$assign));
      }

      var requestObject = null;

      if (fetch) {
        requestObject = fetch(params);
      } else {
        $axios.interceptors.request.use(function (config) {
          Object.keys(headers).forEach(function (v) {
            config.headers[v] = headers[v];
          });
          return config;
        }, function (error) {
          return Promise.reject(error);
        });
        method = method.toLowerCase();

        if (method === 'get') {
          requestObject = $axios[method](url, {
            params: params
          });
        } else {
          requestObject = $axios[method](url, params);
        }
      }

      requestObject.then(function (response) {
        var result = response;

        if (response && !(response instanceof Array)) {
          if (listField && listField.indexOf('.') !== -1) {
            listField.split('.').forEach(function (vv) {
              result = result[vv];
            });
          } else {
            result = response[listField];
          }
        }

        if (!result || !(result instanceof Array)) {
          throw new Error("\u952E".concat(listField, "\u7684\u7ED3\u679C\u4E0D\u662F\u6570\u7EC4\u3002"));
          _this3.loading = false;
          return false;
        }

        if (_this3.dataHandler) {
          _this3.tableData = result.map(_this3.dataHandler);
        } else {
          _this3.tableData = result;
        }

        var totalValue = response;

        if (Object.prototype.toString.call(response) === '[object Array]') {
          totalValue = response.length;
        } else if ((0, _typeof2.default)(response) === 'object') {
          if (totalField && totalField.indexOf('.') !== -1) {
            totalField.split('.').forEach(function (vv) {
              totalValue = totalValue[vv];
            });
          } else {
            totalValue = response[totalField];
          }
        } else {
          totalValue = 0;
        }

        _this3.total = totalValue.length;
        _this3.paginationLayoutTemp = _this3.total >= pagination.pageSize ? _this3.paginationLayoutTemp : 'prev, sizes'; // 分页的相关控制
        // this.total = response.totalElements

        _this3.loading = false;
      }).catch(function (error) {
        // console.error('Get remote data failed. ', error)
        _this3.loading = false;
      });
    },
    emitEventHandler: function emitEventHandler(event) {
      this.$emit.apply(this, [event].concat((0, _toConsumableArray2.default)(Array.from(arguments).slice(1))));
    },
    loadLocalData: function loadLocalData(data) {
      var autoLoad = this.autoLoad;

      if (!data) {
        throw new Error("\u5F53\u7C7B\u578B\u4E3A\u201Clocal\u201D\u65F6\uFF0C\u5FC5\u987B\u8BBE\u7F6E\u5C5E\u6027\u201Cdata\u201D\uFF0C\u5E76\u4E14\u201Cdata\u201D\u5FC5\u987B\u662F\u6570\u7EC4\u3002");
        this.showPagination = false;
        return false;
      }

      var cacheData = JSON.parse(JSON.stringify(data));
      this.cacheLocalData = cacheData;

      if (autoLoad) {
        this.tableData = this.dataFilter(cacheData);
        this.total = cacheData.length;
      }
    }
  }
};
exports.default = _default;